import { createFileRoute } from "@tanstack/react-router";
import { getLegalPages } from "@/lib/legal.functions";
import { LegalPageView, legalMeta } from "@/components/site/legal/LegalPage";

export const Route = createFileRoute("/terminos")({
  loader: () => getLegalPages({ data: { lang: "es" } }),
  head: ({ loaderData }) =>
    loaderData
      ? legalMeta(loaderData.pages.terms, "/terminos")
      : { meta: [{ title: "Términos y Condiciones — Bizaclia.com" }] },
  component: TerminosPage,
});

function TerminosPage() {
  const data = Route.useLoaderData();
  return <LegalPageView page={data.pages.terms} operator={data.operator} />;
}
